import React from "react";
import ConnectBanner from "./ConnectBanner";
import ConnectContent from "./ConnectContent";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
class Connect extends React.Component {
  render() {
    return (
      <div>
        <ConnectBanner />
        <ConnectContent />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(Connect);



// WEBPACK FOOTER //
// ./src/pages/connect/index.js